<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="features" (onEditComplete)="onEditComplete($event)" dataKey="featureId" [paginator]="true"
  [rows]="25" [rowsPerPageOptions]="[100,500,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" selectionMode="single" [(selection)]="feature" [loading]="formLoading"
  styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true"
  [responsive]="true">

  <div class="d-block text-end">
    <span>
      <!--clear filters-->
      <button pButton pRipple class="p-button-text"
        style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="reloadPage()">Clear Filters</button>
    </span>
  </div>

  <ng-template pTemplate="header">

    <!--"propertyFeatureId":17799,
    "featureId":478,
    "shortTermRentalId":1,
    "developmentId":null,
    "activityId":null,
    "guestBookId":null,
    "lastUpdate":null,
    "createDate":null,
    "status":true,
    "title":null,
    "name":"Bed Linens",
    "featureType":"bedroomLinens",
    "featureLabel":"Linens",
    "featureDesc":null,
    "quantity":1,
    "distance":null,
    "distanceUnit":null,
    "describesType":"BD2",
    "kbmMap":"BEDROOM_LINENS_BED_LINENS",
    "vrboMap":null,
    "rentalsUnitedMap":"1436,589,7",
    "privateNotes":null-->

    <tr>
      <th [pSortableColumn]="'featureId'">
        <p-sortIcon [field]="'featureId'"></p-sortIcon>Id
      </th>

      <th [pSortableColumn]="'status'">
        <p-sortIcon [field]="'status'"></p-sortIcon>Status
      </th>

      <th [pSortableColumn]="'featureType'">
        <p-sortIcon [field]="'featureType'"></p-sortIcon>Category
      </th>

      <th [pSortableColumn]="'describesType'">
        <p-sortIcon [field]="'describesType'"></p-sortIcon>Describes
      </th>


      <th [pSortableColumn]="'name'">
        <p-sortIcon [field]="'name'"></p-sortIcon>Name
      </th>

      <th [pSortableColumn]="'title'">
        <p-sortIcon [field]="'title'"></p-sortIcon>Title
      </th>

      <th [pSortableColumn]="'featureDesc'">
        <p-sortIcon [field]="'featureDesc'"></p-sortIcon>Desc
      </th>
      <th [pSortableColumn]="'quantity'">
        <p-sortIcon [field]="'quantity'"></p-sortIcon>Quant
      </th>
      <th [pSortableColumn]="'distance'">
        <p-sortIcon [field]="'distance'"></p-sortIcon>Distance
      </th>
      <th [pSortableColumn]="'distanceUnit'">
        <p-sortIcon [field]="'distanceUnit'"></p-sortIcon>Distance Unit
      </th>
    </tr>

    <tr>
      <td>
        <p-columnFilter type="text" field="featureId" display="menu"></p-columnFilter>
      </td>

      <td>
        <p-dropdown [style]="{'min width':'50px'}" [options]="statuses"
          (onChange)="pt.filter($event.value, 'status', 'contains')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </td>

      <td><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'featureType', 'contains')"></td>

      <td><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'describesType', 'contains')"></td>



      <td><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'name', 'contains')"></td>

      <td><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'title', 'contains')"></td>

      <td>
        <p-columnFilter type="text" field="featureDesc" display="menu"></p-columnFilter>
      </td>
      <td>
        <p-columnFilter type="text" field="quantity" display="menu"></p-columnFilter>
      </td>
      <td>
        <p-columnFilter type="text" field="distance" display="menu"></p-columnFilter>
      </td>
      <td>
        <p-columnFilter type="text" field="distanceUnit" display="menu"></p-columnFilter>
      </td>



    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-feature>
    <tr [pSelectableRow]="feature">
      <td>{{feature.featureId}}</td>
      <!--<td *ngIf="feature.status==1" style="color: grey;">{{getStatusName(feature)}}</td>
      <td *ngIf="feature.status==2" style="color: blue;">{{getStatusName(feature)}}</td>
      <td *ngIf="feature.status==3" style="color: green;">{{getStatusName(feature)}}</td>
      <td *ngIf="feature.status==4" style="color: red;">{{getStatusName(feature)}}</td>-->


      <td [pEditableColumn]="feature" [pEditableColumnField]="'status'">

        <p-inputSwitch (onChange)="onStatusChange($event,feature)" [(ngModel)]="feature.status">
        </p-inputSwitch>
      </td>




      <td>{{trimFeatureType(feature.featureType)}}</td>
      <td>{{feature.describesType}}</td>

      <td>{{feature.name}}</td>
      <td [pEditableColumn]="feature" [pEditableColumnField]="'title'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            @if (feature.status) {
              <input pInputText type="text" [(ngModel)]="feature.title">
            }
          </ng-template>
          <ng-template pTemplate="output">
            @if (feature.status&&!feature.title) {
              <span style="color:lightskyblue;font-size:small">add
              headline</span>
            }
            @if (feature.title&&feature.title.length<=20) {
              <span>{{feature.title}}</span>
            }
            @if (feature.title&&feature.title.length>20) {
              <span>{{feature.title.substring(0,20)}}
              ...</span>
            }
          </ng-template>
        </p-cellEditor>
      </td>





      <td [pEditableColumn]="feature" [pEditableColumnField]="'featureDesc'">
        <p-cellEditor>
          <ng-template  pTemplate="input">
            @if (feature.status) {
              <textarea pInputTextArea type="text" [(ngModel)]="feature.featureDesc" rows="10"
              cols="50"></textarea>
            }
          </ng-template>
          <ng-template pTemplate="output">
            @if (feature.status&&!feature.featureDesc) {
              <span
              style="color:lightskyblue;font-size:small">add description</span>
            }
            @if (feature.featureDesc&&feature.featureDesc.length<=20) {
              <span>{{feature.featureDesc}}</span>
            }
            @if (feature.featureDesc&&feature.featureDesc.length>20) {
              <span
              >{{feature.featureDesc.substring(0,20)}}...</span>
            }

          </ng-template>
        </p-cellEditor>
      </td>





      <td [pEditableColumn]="feature" [pEditableColumnField]="'quantity'">
        <p-cellEditor>
          <ng-template  pTemplate="input">
            @if (feature.status) {
              <input pInputText type="text" [(ngModel)]="feature.quantity">
            }
          </ng-template>
          <ng-template pTemplate="output">
            @if (feature.status&&!feature.quantity) {
              <span style="color:lightskyblue;font-size:small">add
              quantity</span>
            }
            @if (feature.quantity) {
              <span>{{feature.quantity}}</span>
            }
          </ng-template>
        </p-cellEditor>
      </td>

      <td [pEditableColumn]="feature" [pEditableColumnField]="'distance'">
        <p-cellEditor>
          <ng-template  pTemplate="input">
            @if (feature.status) {
              <input pInputText type="text" [(ngModel)]="feature.distance">
            }
          </ng-template>
          <ng-template pTemplate="output">
            @if (feature.status&&!feature.distance) {
              <span style="color:lightskyblue;font-size:small">add
              distance</span>
            }
            @if (feature.distance) {
              <span>{{feature.distance}}</span>
            }
          </ng-template>
        </p-cellEditor>
      </td>

      <td [pEditableColumn]="feature" [pEditableColumnField]="'distanceUnit'">
        <p-cellEditor>
          <ng-template pTemplate="input">
            @if (feature.status) {
              <input pInputText type="text" [(ngModel)]="feature.distanceUnit">
            }
          </ng-template>
          <ng-template pTemplate="output">
            @if (feature.status&&!feature.distanceUnit) {
              <span
              style="color:lightskyblue;font-size:small">add distance type</span>
            }
            @if (feature.distanceUnit) {
              <span>{{feature.distanceUnit}}</span>
            }
          </ng-template>
        </p-cellEditor>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
    : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}}
  </ng-template>
</p-table>